<h2 mat-dialog-title>Re-Shard Case Index for {{selectedCase.caseName}}</h2>
<mat-dialog-content>
  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; margin: 10px">
    <div style="flex: 1 1 0%; box-sizing: border-box;">
      <div>
        <div>
          <mat-label class="title">Current Primary Shard Count</mat-label>
        </div>
        <div style="margin-top: 10px;">{{currentShardCount}}</div>
      </div>
    </div>
    <div style="flex: 1 1 0%; box-sizing: border-box;">
      <div>
        <div>
          <mat-label class="title">Current Averge Primary Shard Size (GB)</mat-label>
        </div>
        <div style="margin-top: 10px;">{{currentShardSize}}</div>
      </div>
    </div>
  </div>
  <form [formGroup]="reshardForm">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Primary Shard Count</mat-label>
      <input type="number" matInput placeholder="New Primary Shard Count" formControlName="primaryShard">
      <mat-error *ngIf="reshardForm.controls['primaryShard'].invalid && (reshardForm.controls['primaryShard'].touched || reshardForm.controls['primaryShard'].dirty)">
        <p *ngIf="reshardForm.controls['primaryShard'].errors.required">New primary shard count is <strong>required</strong></p>
        <p *ngIf="reshardForm.controls['primaryShard'].errors.min || reshardForm.controls['primaryShard'].errors.max">Primary shard count needs to be between 1 and 99 </p>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="start-reshard-form-button" [disabled]="reshardForm.controls['primaryShard'].value === currentShardCount" (click)="start()">Start</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
